<template>
  <div class="dashboard-notices">
    <transition name="notices-fade">
      <button
        v-if="open"
        type="button"
        class="notices-backdrop"
        aria-label="Cerrar avisos y notificaciones"
        @click="open = false"
      ></button>
    </transition>

    <aside class="notices-panel" :class="{ 'is-open': open }" aria-label="Avisos y notificaciones">
      <header class="notices-header">
        <div>
          <h4>AVISOS Y NOTIFICACIONES</h4>
        </div>
        <button
          type="button"
          class="notices-close"
          data-tooltip="CERRAR"
          aria-label="Cerrar"
          @click="open = false"
        >
          <b-icon pack="fas" icon="times" size="is-small"></b-icon>
        </button>
      </header>

      <div class="notices-list">
        <article
          v-for="notice in visibleNotices"
          :key="notice.id"
          class="notice-card"
          :style="{ '--notice-color': notice.color || '#02758f' }"
        >
          <span class="notice-icon">
            <img v-if="notice.iconImage" :src="notice.iconImage" alt="" />
            <b-icon v-else :pack="notice.pack || 'fas'" :icon="notice.icon || 'info-circle'"></b-icon>
          </span>
          <div class="notice-copy">
            <h3>{{ notice.title }}</h3>
            <p v-html="notice.message"></p>
            <router-link
              v-if="notice.action === 'profile'"
              :to="`/agentes/editar/${$store.getters.getSession.id}`"
              class="notice-action"
              @click.native="open = false"
            >
              <i class="fas fa-user-edit" aria-hidden="true"></i>
              ACTUALIZAR FIRMA
            </router-link>
          </div>
        </article>

        <div v-if="!visibleNotices.length" class="notices-empty">
          <b-icon pack="far" icon="bell" size="is-medium"></b-icon>
          <p>No hay avisos para mostrar.</p>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: "DashboardNotices",
  props: {
    notices: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    open: {
      get() {
        return this.$store.getters.getDashboardNotices;
      },
      set(value) {
        this.$store.commit("setDashboardNotices", value);
      },
    },
    visibleNotices() {
      return this.notices.filter((notice) => {
        if (notice.permission && !this.$hasPermission(notice.permission)) return false;
        return !notice.anyPermissions || notice.anyPermissions.some((permission) => this.$hasPermission(permission));
      });
    },
  },
};
</script>

<style lang="scss">
.notices-backdrop {
  position: fixed;
  z-index: 1098;
  inset: 0;
  padding: 0;
  background: rgba(23, 36, 41, 0.3);
  border: 0;
}
.notices-panel {
  position: fixed;
  z-index: 1099;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  width: min(390px, 92vw);
  height: 100vh;
  background: #fff;
  box-shadow: -12px 0 35px rgba(23, 36, 41, 0.15);
  transform: translateX(105%);
  transition: transform 0.28s ease;
}
.notices-panel.is-open {
  transform: translateX(0);
}
.notices-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 17px 16px;
  color: $primary;
  background: #eee;
}
.notices-header h4 {
  margin: 0;
  color: $primary;
  font-size: 10px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.notices-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #666;
  background: #e1e1e1;
  border: 0;
  border-radius: 50%;
  cursor: pointer;

  &::after {
    position: absolute;
    top: 50%;
    right: calc(100% + 8px);
    z-index: 1100;
    padding: 0.35rem 0.55rem;
    color: #fff;
    font-size: 0.68rem;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    content: attr(data-tooltip);
    background: #444;
    border-radius: 4px;
    opacity: 0;
    pointer-events: none;
    transform: translateY(-50%);
    transition: opacity 0.15s ease;
  }

  &:hover,
  &:focus {
    color: #333;
    background: #d9d9d9;
    outline: none;

    &::after {
      opacity: 1;
    }
  }
}
.notices-list {
  flex: 1;
  padding: 14px;
  overflow-y: auto;
}
.notice-card {
  display: flex;
  gap: 12px;
  padding: 14px;
  margin-bottom: 10px;
  background: #fff;
  border: 2px solid var(--notice-color);
  border-radius: 10px;
  box-shadow: none;
}
.notice-icon {
  display: inline-flex;
  flex: 0 0 36px;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  color: var(--notice-color);
  background: #edf1f3;
  border-radius: 50%;

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
}
.notice-copy h3 {
  margin: 0 0 6px;
  color: $primary;
  font-size: 12px;
  font-weight: 700;
}
.notice-copy p {
  margin: 0;
  color: #68747a;
  font-size: 11px;
  line-height: 1.45;
}
.notice-copy p strong {
  color: #4f5b62;
  font-weight: 700;
}
.notice-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 11px;
  padding: 7px 10px;
  color: $primary;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  background: #e7f4f7;
  border: 1px solid #b9e2ea;
  border-radius: 99px;
}
.notices-empty {
  padding: 42px 20px;
  color: #9ba5aa;
  text-align: center;
}
.notices-fade-enter-active,
.notices-fade-leave-active {
  transition: opacity 0.2s ease;
}
.notices-fade-enter,
.notices-fade-leave-to {
  opacity: 0;
}
</style>
